import { Globe2, Sprout, BadgeCheck, FlaskConical, ShieldCheck } from "lucide-react";
import { OPITAC } from "@/lib/site";

const ICONS = [Globe2, Sprout, BadgeCheck, FlaskConical];

export default function OpitacEdge() {
  return (
    <section
      id="opitac"
      data-testid="opitac-section"
      className="relative z-10 bg-[color:var(--relumia-ink)] text-[color:var(--relumia-base)] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-[0.5fr_0.5fr] gap-10 lg:gap-20 items-end mb-16">
          <div>
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-8 bg-[color:var(--relumia-gold)]" />
              <span className="overline !text-[color:var(--relumia-gold)]">The OPITAC™ Edge</span>
            </div>
            <h2 className="font-serif font-light tracking-tight leading-[1.04] text-4xl md:text-5xl lg:text-[3.6rem]">
              A Japanese glutathione, held to a{" "}
              <span className="italic text-gold">higher standard</span>.
            </h2>
            <div
              data-testid="who-gmp-badge"
              className="mt-6 inline-flex items-center gap-2.5 rounded-full border border-[color:var(--relumia-gold)]/40 bg-white/5 px-4 py-2"
            >
              <ShieldCheck size={16} className="text-gold" strokeWidth={1.6} />
              <span className="text-[12.5px] tracking-wide text-white/85">{OPITAC.whoGmp}</span>
            </div>
          </div>
          <p className="text-[15px] leading-relaxed text-white/70 max-w-md">
            {OPITAC.intro} It&apos;s the difference between a glutathione supplement and
            a formulation you can genuinely trust.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {OPITAC.edges.map(([t, d], i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={t}
                data-testid={`opitac-edge-${i}`}
                className="bg-[color:var(--relumia-ink)] p-8"
              >
                <Icon className="text-gold mb-6" size={26} strokeWidth={1.4} />
                <div className="font-serif text-2xl mb-3 leading-tight">{t}</div>
                <p className="text-[13.5px] leading-relaxed text-white/60">{d}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-8 flex items-center gap-3 text-white/40 text-[12px]">
          <span className="h-px w-8 bg-white/20" />
          OPITAC™ glutathione made in Japan by KOHJIN Life Sciences (Mitsubishi Corporation Life Sciences) · Relumia manufactured in India at a WHO-GMP certified plant
        </div>
      </div>
    </section>
  );
}
